const API_ENDPOINT = "https://appserver.move-services.it/" ;
const DECKPOST_ENDPOINT = "https://aws.move-services.it/";
const MOVEFDD_ENDPOINT = "https://movefdd.herokuapp.com/";
const DISP_FFT_ENDPOINT = "https://fftserverbridge.herokuapp.com/fftTransform2";
const ACC_FFT_ENDPOINT = "https://fftserverbridge.herokuapp.com/fftTransform2Acc";
const AUTH_ENDPOINT = API_ENDPOINT;

module.exports = {
    API_ENDPOINT,
    DECKPOST_ENDPOINT,
    MOVEFDD_ENDPOINT,
    AUTH_ENDPOINT,
    DISP_FFT_ENDPOINT,
    ACC_FFT_ENDPOINT
};